/*
	OneSubscribe 1.0.0 Usage
	Yang @onerockwell
	
	OneSubscribe.init({
		el: $('.subscribe-modal'),
		delay: 2000,
		errorMsg: 'Oops, something wrong happened, please try again later',
		successMsg: 'Thank you and welcome to Safiyaa. You will receive an email to confirm your subscription shortly.',
		requiredMsg: 'Error: required field',
		errorEmail: 'Error: please ensure formatting is correct',
		cookieEnabled: false,
		cookieDays: 1
	});
	
*/

// Import all dependencies here
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import OneContact from 'Modules/module-oneContact';

"use strict";

var OneSubscribeView = Backbone.View.extend({
		
	initialize: function (settings) {
		var self = this;
		if (!self.$el.length) {
			return false;
		}
		
		self.$modal = self.$el;
		self.errorMsg = settings.errorMsg || self.$modal.data('errormsg');
		self.successMsg = settings.successMsg || self.$modal.data('successmsg');
		self.errorRequired = settings.requiredMsg || self.$modal.data('requiredmsg');
		self.errorEmail = settings.errorEmail || self.$modal.data('erroremail');
		self.delay = settings.delay || self.$modal.data('delay');
		self.days = settings.cookieDays || self.$modal.data('cookiedays');
		self.enabled = settings.errorMsg || self.$modal.data('enabled');
		self.cookieEnabled = settings.cookieEnabled || self.$modal.data('cookieenabled');
		
		if (!self.enabled) {
			return false;
		}
		
		self.$form = self.$modal.find('form');
		
		if (!ORW.utilities.getCookie('hidesubscriptionmodal') || !self.cookieEnabled) {
			setTimeout(function(){
				self.open();
			}, self.delay);
		}
		
		OneContact.init({
			el: self.$modal,
			submitType: 'json',
			errorMsg: self.errorMsg,
			successMsg: self.successMsg,
			requiredMsg: self.errorRequired,
			errorEmail: self.errorEmail,
			successCallback: function(data) {
				self.submitCallBack(true,data);
			},
			errorCallback: function(err) { 
				self.submitCallBack(false,err);
			}
		});
		
		console.log('Subscribe Modal Init');
	
	},

	events: {
		'click .close' : function(e){
			e.preventDefault();
			var self = this;
			self.close(true);
		},
		'click .global-message a' : function(e){
			e.preventDefault();
			var $curr = $(e.currentTarget);
			if ($curr.attr('href')) {
				window.open($curr.attr('href'));
			}
		},
		'click .global-message' : function(e){
			var self = this;
			self.$form.parent().removeClass('submitted error success');
		}
	},
	
	open: function() {
		var self = this;
		self.$modal.addClass('opened');
	},
	
	close: function(setCookie) {
		var self = this;
		self.$modal.removeClass('opened');
		if (setCookie && self.cookieEnabled) {
			ORW.utilities.setCookie('hidesubscriptionmodal',true,self.days);
		}
	},
	
	submitCallBack: function(isSuccess,data){
		var self = this;
		
		var errorHandling = function( $form, msg, flag ){
			var $container = $form.parent();
			var $globalMsg = $container.find('.global-message');
			msg = '<span>' + msg + '</span>';
			
			if ($globalMsg.length) {
				$globalMsg.html(msg);
			} else {
				$container.append('<p class="global-message">' + msg + '</span>');
				$globalMsg = $container.find('.global-message');
			}
			
			$container.removeClass('submitted error success');
			
			if (flag == 'success') {
				// Clear up the form
				_.each($form.find('.group input'), function(input){
					var $input = $(input);
					if ($input.attr('type') != 'checkbox' && $input.attr('type') != 'radio') {
						$input.val('');
					} else if ($input.attr('type') == 'checkbox') {
						$input.removeAttr('checked');
					}
				});
				$container.addClass('submitted success');
			} else if (flag == 'error') {
				$container.addClass('submitted error');
			}
		};
		
		errorHandling(self.$form, '', '');
		
		if (isSuccess) {
			console.log(data);
			if (data.result != "success") {
				errorHandling(self.$form, data.msg, 'error');
			} else {
				// Successed!
				errorHandling(self.$form, self.successMsg, 'success');
				var delay = self.delay > 3000 ? self.delay : 3000;
				setTimeout(function(){
					self.close(true);
				}, delay);
			}
		} else {
			errorHandling(self.$form, self.errorMsg, 'error');
		}
	},
	
	destroy: function() {
		var self = this;
		self.undelegateEvents();
	}

});

var OneSubscribe = {
	init: function (settings) {
		return new OneSubscribeView(settings);
	}
}

export default OneSubscribe;